export default "__VITE_ASSET__kMh9HJ9F__"